import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["centered", "defaultValue", "enlargeOnSelect", "height", "id", "isFlat", "isShowingDescriptionOnSelect", "layout", "name", "onChange", "onDisabledClick", "onLayout", "options", "shouldWordsBreak", "singleRow", "size", "testID", "UNSAFE_containerProps", "UNSAFE_inputProps", "value"];
import React from 'react';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { BoxSelectorBase } from './BoxSelectorBase';
import { Option } from './Option';
var BoxSelectorDetailed = _ref => {
  var {
      centered,
      defaultValue,
      enlargeOnSelect,
      height,
      id,
      isFlat,
      isShowingDescriptionOnSelect,
      layout,
      name,
      onChange,
      onDisabledClick,
      onLayout,
      options,
      shouldWordsBreak,
      singleRow,
      size,
      testID,
      UNSAFE_containerProps,
      UNSAFE_inputProps,
      value
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'BoxSelectorDetailed',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(BoxSelectorBase, _extends({
    defaultValue: defaultValue,
    enlargeOnSelect: enlargeOnSelect,
    height: height,
    id: id,
    isFlat: isFlat,
    isShowingDescriptionOnSelect: isShowingDescriptionOnSelect,
    layout: layout,
    left: !centered,
    name: name,
    onChange: onChange,
    onDisabledClick: onDisabledClick,
    onLayout: onLayout,
    options: options,
    shouldWordsBreak: shouldWordsBreak,
    singleRow: singleRow,
    size: size,
    testID: testID,
    UNSAFE_containerProps: UNSAFE_containerProps,
    value: value
  }, props, {
    renderOption: renderProps =>
    /*#__PURE__*/
    // @ts-expect-error error appeared after adding types for ramda
    React.createElement(Option, _extends({
      UNSAFE_inputProps: UNSAFE_inputProps
    }, renderProps))
  }));
};
BoxSelectorDetailed.displayName = 'BoxSelectorDetailed';
export default BoxSelectorDetailed;
//# sourceMappingURL=index.js.map